import { apiClient } from "@/lib/api-client";
import { SLACK_SIGN_IN_PATH, type SlackSignInOptionsResp } from "@/types/slackSignIn.ts";
import { queryOptions } from "@tanstack/react-query";

/**
 * Whether the sign-in screen may offer Sign in with Slack, for web and native
 * alike. Read from the server rather than Statsig because the screen renders
 * before anyone is signed in. A failure answers "no", so a client live against
 * an older API never shows a door the API does not have.
 */
export const slackSignInOptionsQuery = queryOptions({
  queryKey: ["slackSignIn", "options"] as const,
  queryFn: async ({ signal }) => {
    const res = await apiClient.get<SlackSignInOptionsResp>(`${SLACK_SIGN_IN_PATH}/options`, {
      signal,
    });
    return res.data;
  },
  retry: false,
  staleTime: 60_000,
});
